<template>
    <VasionGeneralModal
      id="api-lookup-example-data-modal"
      confirmButtonText="OK"
      modalTitle="Example Data"
      modalType="slot"
      :showRejectButton="false"
      :sync="sync"
      @confirmButtonClick="closeClick()"
    >
    <span class="example-url">URL: {{ exampleURL }}</span>
    <pre 
      v-if="hasHeaders"
      class="example-data">{{ headers }}</pre>
    <pre 
      v-if="hasExampleData"
      class="example-data">{{ exampleData }}</pre>
    </VasionGeneralModal>
  </template>
  
  <script>
  export default {
    name: 'ApiLookupExampleDataModal',
    props: {
      sync: {
        type: Boolean,
        default: false,
        required: false,
      },
      exampleData: {
        type: String,
        required: true,
      },
      exampleHeaders: {
        type: Array,
        required: true,
      },
      exampleURL: {
        type: String,
        required: true,
      },
    },
    data: function () {
      return {
        defaultLookup: false,
        firstRecordOnly: false,
      }
    },
    computed: {
      hasExampleData() {
        return this.exampleData && this.exampleData?.length > 0;
      },
      hasHeaders() {
        return this.exampleHeaders && this.exampleHeaders?.length > 0;
      },
      headers() {
        if (!this.hasHeaders) {
          return '';
        }
          if (!Array.isArray(this.exampleHeaders)) {
            return '';
        }
        return this.exampleHeaders
          .map(header => `${header.Key}: ${header.Value.join(', ')}`)
          .join('\n');
      },
    },  
    methods: {
      closeClick() {
        this.$emit('closeModal')
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import '@/assets/css/vuetify3Breakpoints.scss';
  
  .api-lookup-example-data-modal {
    width: 100%;
    height: 300px;
  
    @include breakpoint(md) {
      width: 500px;
    }
  }

  ::v-deep .modal-container {
    width: calc(100% - 500px);
    min-width: 600px;
    max-width: 1000px;
  }

  ::v-deep .vasion-general-modal {
    width: 100%;
    max-width: 100% !important;
  }

  .example-data {
    margin-top: 20px;
    white-space: pre-wrap; 
    word-wrap: break-word; 
  }

  .example-url {
    min-width: 400px;
    margin-top: 10px;
    display: block;
  } 

  ::v-deep .checkbox {
    margin-right: 4px;
  }
  </style>
  